/*
 * @Description: web方法封装
 */
import storage from '../storage'

const init = async () => {
  return true
}

const xbbLocalStorageSet = (data) => storage.LS.set(data.key, data.value, data.expired)

const xbbLocalStorageGet = (data) => storage.LS.get(data.key)

const xbbLocalStorageRemove = (data) => storage.LS.remove(data.key)

const xbbLocalStorageClear = () => storage.LS.clear()

export default {
  init,
  xbbLocalStorageSet,
  xbbLocalStorageGet,
  xbbLocalStorageRemove,
  xbbLocalStorageClear
}
